import { Add } from '@mui/icons-material';
import { Alert, IconButton } from '@mui/material';
import React, { useState } from 'react';
import { addProductDetail } from '../../../api/products';
import Modal from '../../elements/Modal';
import ProductForm from './ProductSpecsForm';

export default function AddProductSpecs({
  fetchData,
  product,
  token,
  setMessage,
  setSnackbarOpen,
}) {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (values) => {
    setError(null);

    try {
      const payload = {
        ...values,
        productId: product.id,
      };
      const response = await addProductDetail(payload, token);
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.error?.message || errorResponse.message);
      }
      setSnackbarOpen(true);
      setMessage('Product details added successfully');
      fetchData();
      handleClose();
    } catch (error) {
      setError(error.message || 'Failed to add a new spec');
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(null);
  };

  return (
    <>
      <IconButton variant="text" onClick={handleClickOpen}>
        <Add />
      </IconButton>
      <Modal
        open={open}
        modalTitle="Add Product Detail"
        handleClose={handleClose}
        width={'sm'}>
        {error && <Alert severity="error">{error}</Alert>}
        <ProductForm onSubmit={handleSubmit} product={product} />
      </Modal>
    </>
  );
}
